import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartQuantityItem, Drug, QuantityDetails } from '../../models';
import { CartService, DataService } from '../../services';

@Component({
  selector: 'app-single-drug-details',
  templateUrl: './single-drug-details.component.html',
  styleUrls: ['./single-drug-details.component.scss']
})

export class SingleDrugDetailsComponent implements OnInit {
  cartItems: Drug[] = [];
  drug: Drug;
  selectedImageIndex: number = 0;
  selectedImage: string = '';
  isShowAddCart: boolean = true;
  isMedicalConsultation: boolean = false;
  selectedQuantityType: QuantityDetails;
  isUpdateDrugQuantityType: { [drugId: number]: boolean } = {};
  productQuantities: CartQuantityItem[] = [];

  constructor(
    private cartService: CartService,
    private dataService: DataService,
    private router: Router,
    ) {}

  ngOnInit(): void {
    this.dataService.getLocalDataToView().subscribe(dataToView => {
      if (dataToView !== null) {
        this.drug = dataToView as Drug;
        if (this.drug && this.drug.quantity_types && this.drug?.quantity_types?.length > 0) {
          this.selectedQuantityType = this.drug.quantity_types?.[0] ?? null;
        }
      } else {
        this.router.navigate(['/pharmacy']);
      }
    });
    this.cartService.getCartProducts().subscribe(cartItems => {
      this.cartItems = cartItems;
    });
  }

  onQuantityTypeChange(quantityType: QuantityDetails) {
    this.selectedQuantityType = quantityType;
    const cartItem = this.cartItems.find(item => item.id === this.drug.id);
    const productQuantity = this.productQuantities.find(product => product.productId === this.drug.id);
    this.isUpdateDrugQuantityType[this.drug.id] = !!(cartItem && productQuantity?.quantity_type !== quantityType.name);
    this.productQuantities = JSON.parse(localStorage.getItem('cartItemQuantities') || '[]');
  }

  selectImage(index: number) {
    if (this.drug && this.drug.images && this.drug.images.length > 1) {
      this.selectedImageIndex = index;
      this.selectedImage = this.drug.images[index];
    }
  }

}
